import { useMemo } from 'react';

import { useQuery } from '@apollo/client';
import ProductImagesByIdsQuery from '@graphql/queries/ProductImagesByIdsQuery';
import { handleAzureMigratedImages } from 'containers/Product/helper';

interface ProductImagesData {
  allProducts: {
    nodes: { id: number; productImages: { nodes: { url: string }[] } }[];
  };
}

/** Thumbnail URL per product id; products without an image are absent. */
const useProductImages = (ids: number[]): Map<number, string> => {
  const { data } = useQuery<ProductImagesData>(ProductImagesByIdsQuery, {
    variables: { ids },
    skip: ids.length === 0,
  });
  return useMemo(() => {
    const urls = new Map<number, string>();
    data?.allProducts.nodes.forEach((p) => {
      const raw = p.productImages.nodes[0]?.url;
      const url = raw && handleAzureMigratedImages(raw);
      if (url) urls.set(p.id, url);
    });
    return urls;
  }, [data]);
};

export default useProductImages;
